export class ListItemData {
    public Id: string | number;
    public Description: string;
    constructor(id: string | number, description: string) {
        this.Id = id;
        this.Description = description;
    }
}